import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { WorkbookList, WorkSpace, WorkSpaceList } from '../models/workspace.models';

@Injectable({
  providedIn: 'root'
})
export class WorkspaceService {
  dynamicTableAPI: string;
  constructor(private http: HttpClient) {
    this.dynamicTableAPI = environment.dynamicTableAPI; 
   }

   //Get Workspace by Id
   getWorkspaceList(): Observable<WorkSpaceList[]> {
    return this.http.get<any>(`${this.dynamicTableAPI}Workspace`);
  }
  
  // Add new Workspace
  addNewworkspace(newWorkSpace: WorkSpace): Observable<any> {
    return this.http.post<any>(`${this.dynamicTableAPI}workspace`, newWorkSpace);
  }
  
  // Update Existing Workspace
  updateworkspace(workSpaceList: WorkSpaceList): Observable<any> {
    return this.http.put<any>(`${this.dynamicTableAPI}workspace`, workSpaceList);
  }

  //DeleteWorkspaceByID 
  deleteWorkspaceByID(workspaceId: string) {
    return this.http.delete<any>(`${this.dynamicTableAPI}Workspace/${workspaceId}`);
  }

  //Get WorkspaceDetails by Id
  getWorkspaceDetailsByID(workspaceId: string): Observable<WorkSpaceList> {
    return this.http.get<any>(`${this.dynamicTableAPI}Workspace/${workspaceId}`);
  }  

  //Get WorkspaceDetails by Id
  getWorkspaceItemsDetailsByID(workspaceId: string): Observable<WorkbookList[]> {
    return this.http.get<any>(`${this.dynamicTableAPI}Workspace/${workspaceId}/Workbook`);
  }  
  
  //Add New Workbook in workspace  
  addNewWorkbookInWorkspace(workspaceId: string, data: any): Observable <any> {
    const formData = new FormData();
    if(data?.file && data?.file?.name){
      formData.append('file', data.file, data.file.name);
    }
    formData.append('name', data.name);
    return this.http.post<any>(`${this.dynamicTableAPI}Workspace/${workspaceId}/Workbook`, formData, {})
  }
   
  addNewWorkbookWithHeaderMapping(workspaceId: string, data: any, fieldMappings:string): Observable <any> {
    const formData = new FormData();
    if (data?.file?.name) {
      formData.append('File.File', data.file, data.file.name);
    }
    if (data?.name) {
      formData.append('File.Name', data.name);
    }
    if (fieldMappings) {
      formData.append('HeaderMappings', fieldMappings);
    }
    return this.http.post<any>(`${this.dynamicTableAPI}Workspace/${workspaceId}/WorkbookWithHeaderMapping`, formData, {})
  }

  getWorkbookFileHeaderMapping(data:any): Observable<any> {
    const formData = new FormData();
    if (data?.file?.name) {
      formData.append('File', data.file, data.file.name);
    }
    if (data?.name) {
      formData.append('Name', data.name);
    }
    return this.http.post<any>(`${this.dynamicTableAPI}Workspace/GetFileHeaderDataType`, formData, {})
  }
  
  copyWorkbookWithColumns(data: { destinationWorkspaceId: string; workbookId: string; workbookName: string; columnIds?: string[] }): Observable<any> {
    return this.http.post<any>(`${this.dynamicTableAPI}Workspace/WorkbookWithColumns`, data);
  }
}
